module.exports = __webpack_public_path__ + "img/ahara.9b6aa949.jpg";